function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.5 2.5a1 1 0 00-1 1v10h-10a1 1 0 00-1 1v1a1 1 0 001 1h10v10a1 1 0 001 1h1a1 1 0 001-1v-10h10a1 1 0 001-1v-1a1 1 0 00-1-1h-10v-10a1 1 0 00-1-1h-1z",
  fill: "currentColor"
})));